<template>
  <div v-html="detailunit"></div>
</template>

<script>
export default {
  data: () => ({
    detailunit: 'https://simotor.id/detail_transaksi/11432'
  })
};
</script>
